export default __webpack_public_path__ + "static/media/423.316874ea.jpg";